import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// Lazy load all page components for code splitting
const Home = lazy(() => import('./pages/Home'));
const HelpForm = lazy(() => import('./pages/HelpForm'));
const DonorForm = lazy(() => import('./pages/DonorForm'));
const VolunteerForm = lazy(() => import('./pages/VolunteerForm'));
const MapView = lazy(() => import('./pages/MapView'));
const FindCenters = lazy(() => import('./pages/FindCenters'));
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const CoordinatorForm = lazy(() => import('./pages/CoordinatorForm'));
const CoordinatorRegistration = lazy(() => import('./pages/CoordinatorRegistration'));
const CoordinatorDashboard = lazy(() => import('./pages/CoordinatorDashboard'));

// Optimized loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="inline-block animate-spin rounded-full h-8 w-8 border-2 border-primary-600 border-t-transparent"></div>
      <p className="mt-3 text-sm text-gray-600">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <AuthProvider>
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
          <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/help" element={<HelpForm />} />
          <Route path="/donate" element={<DonorForm />} />
          <Route path="/volunteer" element={<VolunteerForm />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/centers" element={<FindCenters />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/coordinators/create" 
            element={
              <ProtectedRoute>
                <CoordinatorForm />
              </ProtectedRoute>
            } 
          />
          {/* <Route 
            path="/coordinator/dashboard" 
            element={
              <ProtectedRoute>
                <CoordinatorRegistration />
              </ProtectedRoute>
            } 
          /> */}
          <Route 
            path="/coordinator/dashboard" 
            element={
              <ProtectedRoute>
                <CoordinatorDashboard />
              </ProtectedRoute>
            } 
          />
        </Routes>
          </Suspense>
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;